export const accordionTypes = {
    CompletePage: 'completePage'
};
